<vng-sidenav [opened]="false">
  <router-outlet></router-outlet>
</vng-sidenav>
